import Vue from "vue";
import VueI18n from "vue-i18n";
import { getBrandName } from "./utils/domainMapping";

Vue.use(VueI18n);

// 动态加载多语言文案
function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

// 递归替换 {SoouPay}
export const replaceSoouPay = (data) => {
  const brandName = getBrandName();
  if (typeof data === "string") {
    return data.replace(/{SoouPay}/g, brandName);
  } else if (Array.isArray(data)) {
    return data.map((item) => replaceSoouPay(item)); // 递归处理数组元素
  } else if (typeof data === "object" && data !== null) {
    const result = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        result[replaceSoouPay(key)] = replaceSoouPay(data[key]); // 递归处理键和值
      }
    }
    return result;
  }
  return data;
};

// 自定义格式化器
const customFormatter = {
  interpolate(message, values) {
    return replaceSoouPay(message); // 使用递归函数处理
  },
};

// // 自定义格式化器
// const customFormatter = {
//   interpolate(message, values) {
//     const brandName = getBrandName();
//     if (typeof message === "string") {
//       return message.replace(/{SoouPay}/g, brandName);
//     }
//     return message; // 非字符串保持不变
//   },
// };

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
  formatter: customFormatter, // 添加自定义格式化器
});

export default i18n;
